import React from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { PageTracker } from "@/components/PageTracker";
import { PromoBanner } from "@/components/PromoBanner";
import { ConciergeChat } from "@/components/ConciergeChat";

export const SiteLayout = () => (
  <div className="App">
    <a href="#main-content" className="skip-link">Zum Inhalt springen</a>
    <PageTracker />
    <PromoBanner />
    <Navbar />
    <main id="main-content" style={{ paddingTop: "var(--promo-h, 0px)" }}><Outlet /></main>
    <Footer />
    <ConciergeChat />
  </div>
);
